<template>
    <div :class="['page book-now',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content copper">
            <div class="wpb_wrapper">

            </div>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';
import WebSoc from '@/utils/WebSoc.js';
import Ham from '@/components/Ham.vue'
import Alert from '@/utils/Alert.js'

export default {
    name: 'book-now',
    mixins: [ pageOn ],
    components: {
        VHeader,
    },
    data () {
        return {

        }
    },
    mounted () {
        var div = document.createElement('div');
        var script = document.createElement('script');
            script.id = 'book-now';
            script.src = '//partners.designmynight.com/pf/js?venue_id=5c890df87864b535b0467d74';
            div.appendChild(script);
        var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.src = 'https://partners.designmynight.com/css/partner-form.css?v=1595425168';
            div.appendChild(link);
            this.$el.querySelector('.wpb_wrapper').appendChild(div);

    }, 
    methods: {
        startBook () {
            return;
            var DMN = window.DMN;
            console.log(Date.now(),DMN);
            if ( !DMN ) { console.log('!DMN'); return setTimeout(() => this.startBook(),50); }
            console.log('got ya !');
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    }
}

</script>

<style>
.dmn-form {
    margin: 10px calc(50% - 103px);
}
</style>